/* eslint-disable sort-exports/sort-exports */

/**
 * The width of the cursor stroke.
 *
 * @constant {number}
 */
export const CursorStrokeWidth = 1.5;

/**
 * The width of the cursor shadow stroke.
 *
 * @constant {number}
 */
export const CursorShadowStrokeWidth = CursorStrokeWidth * 2;

/**
 * The width of the bounding box stroke.
 *
 * @constant {number}
 */
export const BoundingBoxStrokeWidth = 2;

/**
 * The width of the bounding box shadow stroke.
 *
 * @constant {number}
 */
export const BoundingBoxShadowStrokeWidth = BoundingBoxStrokeWidth * 2;

/**
 * The initial scale of the fast frame.
 *
 * @constant {number}
 */
export const InitialScale = 0.5;

/**
 * The opacity of the scrim.
 *
 * @constant {number}
 */
export const ScrimOpacity = 0.5;

/**
 * The opacity of the shadow.
 *
 * @constant {number}
 */
export const ShadowOpacity = 0.65;

/**
 * The keys that can be used to escape fast frame.
 *
 * @constant {number|string[]}
 */
export const EscapeKeys = [27, 'Escape'];

/**
 * The keys that can be used to confirm fast frame.
 *
 * @constant {number|string[]}
 */
export const EnterKeys = [13, 'Enter'];
